import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  // Only show language switcher in development mode
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  const toggleLanguage = () => {
    const newLanguage = i18n.language === 'he' ? 'en' : 'he';
    i18n.changeLanguage(newLanguage);
  };

  const currentLanguageLabel = i18n.language === 'he' ? 'עברית' : 'English';
  const nextLanguageLabel = i18n.language === 'he' ? 'English' : 'עברית';

  return (
    <button
      onClick={toggleLanguage}
      className="group relative overflow-hidden flex items-center space-x-2 px-4 py-2 text-sm font-medium rounded-xl transition-all duration-300 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-vibrant-orange"
      style={{
        background: 'var(--space-nav-bg)',
        color: 'var(--space-nav-text-primary)',
        border: '1px solid var(--space-nav-border)',
        backdropFilter: 'blur(10px)',
        boxShadow: '0 4px 12px var(--space-nav-shadow)',
      }}
      title={`Switch to ${nextLanguageLabel}`}
    >
      {/* Glow effect overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent opacity-0 group-hover:opacity-10 transition-opacity duration-300 transform -skew-x-12" />
      
      {/* Content */}
      <span className="relative flex items-center space-x-2">
        <span>{currentLanguageLabel}</span>
        <Globe className="w-4 h-4 transform group-hover:rotate-12 transition-transform duration-300" />
        <span className="text-xs opacity-60">🌍</span>
      </span>
    </button>
  );
};

export default LanguageSwitcher; 